jQuery(document).ready(function($){

    setInterval(function(){

        /* Effetto logo principale del sito web */
        if($(window).width() > 960){

            if($(".hero-section").length != 0){

                $.each($(".logo-wrapper"), function(index, el){
    
                    var logo_wrapper        = $(this);
                    var current_logo        = $(logo_wrapper).find(".logo.current-logo");
    
                    var current_logo_middle_height      = $(current_logo).offset().top+$(current_logo).height()/2;
    
                    var found               = false;
    
                    $(current_logo).removeClass("bg-grey");
    
                    $.each($(".hero-section, .uk-section-secondary"), function(index, el){
    
                        var c_top               = $(el).offset().top;
                        var c_height            = $(el).offset().top+$(el).outerHeight(true);
    
                        if(current_logo_middle_height >= c_top && current_logo_middle_height <= c_height){
                            found       = true;
                        }
    
                    });
    
                    if(found == true){
                        $(current_logo).attr('src', $(".logo.white-logo").attr('src'));
                        
                    }else{
                        $(current_logo).attr('src', $(".logo.blue-logo").attr('src'));
                    }
    
                });
    
    
            }else{
                $(".current-logo").attr('src', $(".logo.blue-logo").attr('src'));
                $(".current-logo").addClass("bg-grey");
            }

        }else{
            $(".current-logo").attr('src', $(".logo.mobile").attr('src'));
            $(".current-logo").addClass("bg-grey");
        }

        /* Effetto loghi social */
        if($(".social-fixed-container").length != 0){

            var d_hero              = $(".hero-section").offset().top + $(".hero-section").outerHeight(true);
            var d_social            = $(".social-fixed-container").offset().top + $(".social-fixed-container").outerHeight(true);
            var STOP_BOTTOM_MARGIN  = 50;

            if(d_social > d_hero){
                $(".social-fixed-container").addClass("social-box");
            }else{
                $(".social-fixed-container").removeClass("social-box");
            }

            if(d_social > ($("#footer").offset().top - STOP_BOTTOM_MARGIN)){

                /* 80 è il margin top negativo impostato sul contenitore, devo quindi controbilanciare */
                $(".social-fixed-container").css({
                    top         : parseInt($("#footer").offset().top - $(".social-fixed-container").outerHeight(true) + 80 - STOP_BOTTOM_MARGIN) + 'px',
                    height      : $(".social-fixed-container").height(),
                    position    : 'absolute'
                });
            }

            if(($(window).scrollTop() + $(window).height()) < ($("#footer").offset().top - STOP_BOTTOM_MARGIN)){
                $(".social-fixed-container").css({
                    top         : 'unset',
                    position    : 'fixed'
                });
            }

        }

    }, 100);
});